<template>
  <div class="wrapper">
    <!-- <div class="content">
      <img src="../../assets/img/pc.png" alt="" />
      <p>知心慧学网页版登录确认</p>
    </div>
    <div class="footer">
      <button @click="handleLogin" :disabled="canClick">登录</button>
      <button @click="handleFinish">取消</button>
    </div> -->
  </div>
</template>

<script>
// import Http from "../../lib/Http";
export default {
  name: "surelogin",
  data() {
    return {
      // upDataToken: "",
      // needQrId: "",
      // clientType: "",
      baseUrl:
        process.env.NODE_ENV === "production"
          ? "https://www.zhixinhuixue.com/copyRight/"
          : "http://zsy.dev.xueping.com/copyRight/",
      // err: null,
      // succ: null,
      // canClick: false,
    };
  },
  created() {
    const userAgentInfo = navigator.userAgent;
    const Agent = userAgentInfo.search("app_zxhx_zsyte");
    if (Agent == -1) {
      window.location.href = `${this.baseUrl}/teacherdownload.html`;
    } else {
      const isiOS = !!userAgentInfo.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) {
        this.clientType = isiOS;
      } else {
        this.clientType = isiOS;
      }
    }

    // const { token, qrId } = this.$route.query;
    // this.upDataToken = token;
    // this.needQrId = qrId;
    // if (this.upDataToken && this.needQrId) {
    //   this.getVerify();
    // }
  },
  methods: {
    // getVerify() {
    //   Http.zsyPutHttp(
    //     `/auth/teacher/qrcode/login/${this.needQrId}/verify`,
    //     {
    //       token: this.upDataToken,
    //     },
    //     (ok) => {
    //       this.succ = ok;
    //       console.log(ok);
    //     },
    //     (fail) => {
    //       window.webkit.messageHandlers.ZXHXJsListener.postMessage({
    //         msg: "参数错误",
    //         status: 0,
    //       });
    //     },
    //     (ca) => {
    //       console.log(ca);
    //     },
    //     true
    //   );
    // },
    // handleLogin() {
    //   let _this = this;
    //   this.canClick = true;
    //   Http.zsyPutHttp(
    //     `/auth/teacher/qrcode/login/${this.needQrId}/confirm`,
    //     {
    //       token: this.upDataToken,
    //     },
    //     (ok) => {
    //       _this.succ = ok;
    //       if (this.clientType) {
    //         this.canClick = false;
    //         window.webkit.messageHandlers.ZXHXJsListener.postMessage({
    //           msg: "登录成功",
    //           status: 1,
    //         });
    //       } else {
    //         window.ZXHXJsListener.onFinish();
    //       }
    //     },
    //     (fail) => {
    //       this.canClick = false;
    //       _this.err = fail;
    //       window.webkit.messageHandlers.ZXHXJsListener.postMessage({
    //         msg: "登录失败",
    //         status: 0,
    //       });
    //     },
    //     (ca) => {
    //       this.canClick = false;
    //       console.log(ca);
    //     },
    //     true
    //   );
    // },
    // handleFinish() {
    //   if (this.clientType) {
    //     window.webkit.messageHandlers.ZXHXJsListener.postMessage({ status: 2 });
    //   } else {
    //     window.ZXHXJsListener.onFinish();
    //   }
    // },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  .content {
    position: absolute;
    top: 2.16rem;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    img {
      width: 3.96rem;
      height: 3.1rem;
      margin-bottom: 0.4rem;
    }
    p {
      text-align: center;
    }
  }
  .footer {
    position: absolute;
    bottom: 1.5rem;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;

    button:first-child,
    button:last-child {
      margin: 0;
      padding: 0;
      border: 1px solid transparent; //自定义边框
      outline: none;
      width: 4.3rem;
      border-radius: 0.44rem;
      font-size: 0.36rem;
    }
    button:first-child {
      width: 4.3rem;
      height: 0.88rem;
      line-height: 0.88rem;
      background-color: rgba(98, 183, 93, 1);
      color: #fff;
      margin-bottom: 0.38rem;
    }
    button:last-child {
      // color: #555555;
      background-color: #ffffff;
    }
  }
}
</style>


// WEBPACK FOOTER //
// surelogin.vue?f1be88ac